import { defineStore } from "pinia";

export const useBankStore = defineStore('bank', {
    state: () => ({
        bank: {},
        banks: [],
        banksSelect: [],
        loading: false,
    }),
    actions: {
        setLoading(state, loading) {
            state.loading = loading
        },
        setBank(bank) {
            this.bank = bank
        },
        setBanksSelect(banksSelect) {
            this.banksSelect = banksSelect
        },
        setBanks(banks) {
            this.banks = banks
        },
        addBank(bank) {
            this.banks.unshift(bank)
        },
        updateBank(bank) {
            let index = this.banks.findIndex(cl => cl.id === bank.id)
            this.banks.splice(index, 1, bank)
        },
        deleteBank(bank) {
            let index = this.banks.findIndex(cl => cl.id === bank.id)
            this.banks.splice(index, 1)
        },
    },
});